import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import SidebarContent from "./SidebarContent";
import { APP_VERSION } from "../../version";
import { networkService } from "@/services/network.service"; // ✅ importa networkService
import { fetchVersionInfo, getCurrentTrack } from "@/services/app/app-update.service";
import { compareVersions } from "compare-versions";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar = ({ isOpen, onClose }: SidebarProps) => {
  const [remoteVersion, setRemoteVersion] = useState<string | null>(null);
  const { theme } = useThemeConfig();

  useEffect(() => {
    const fetchVersion = async () => {
      if (!networkService.isOnline()) {
        console.warn("[Sidebar] Offline, salto il fetch della versione.");
        return;
      }

      const info = await fetchVersionInfo(getCurrentTrack());
      if (info) {
        setRemoteVersion(info.version);
        localStorage.setItem('app_update_latest_version', info.version);
        localStorage.setItem('app_update_mandatory', info.mandatory ? 'true' : 'false');
        const dismissed = localStorage.getItem('app_update_dismissed_version');
        if (
          compareVersions(info.version, APP_VERSION) > 0 &&
          (info.mandatory || dismissed !== info.version)
        ) {
          window.dispatchEvent(
            new CustomEvent('appUpdateAvailable', { detail: info })
          );
        }
      }
    };

    fetchVersion();
  }, []);

  const overlayColor = `${theme.backgroundColor}80`;

  return (
    <>
      <div
        className={`fixed inset-0 z-40 transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        style={{ backgroundColor: overlayColor }}
        onClick={onClose}
      />

      <aside
        className={`sidebar-container fixed top-0 left-0 h-full w-64 z-[9999] transform transition-transform duration-300 ease-in-out shadow-lg flex flex-col ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
        style={{ backgroundColor: theme.sidebarColor }}
      >
        <div style={{ height: '20px' }} />

        <div
          className="flex justify-between items-end px-4 border-b"
          style={{
            borderColor: theme.borderColor,
            color: theme.textPrimaryColor,
            paddingTop: 'calc(var(--safe-area-top, 0px) + 0.75rem)',
            paddingBottom: '0.5rem',
          }}
        >
          <div className="flex items-end gap-x-2">
            <h2 className="font-semibold text-xl leading-none">Menu</h2>
            <span className="text-xs leading-none">
              v{APP_VERSION}
              {remoteVersion && compareVersions(remoteVersion, APP_VERSION) > 0
                ? ` (${remoteVersion})`
                : ''}
            </span>
          </div>

          <button
            onClick={onClose}
            className="p-1 rounded-full transition-colors"
            aria-label="Chiudi menu"
            style={{
              borderRadius: theme.buttonBorderRadius,
              transition: `all ${theme.transitionSpeed} ease`,
            }}
          >
            <X className="h-5 w-5" />
          </button>
        </div>



        <SidebarContent onClose={onClose} />
      </aside>
    </>
  );
};

export default Sidebar;
